import {Component, inject} from '@angular/core'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-kalp-info',
  templateUrl: './kalp-info.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [KalpItemComponent]
})
export class KalpInfoComponent {
  public readonly loanService = inject(LoanService)
}
